





































import { Vue, Component } from 'vue-property-decorator';

import UnorderedList from '@/components/Atoms/List/UnorderedList.vue';
import ListItem from '@/components/Atoms/ListItem/ListItem.vue';
import RadioButton from '@/components/Atoms/Input/RadioButton.vue';
import Price from '@/components/Atoms/Text/Price.vue';

@Component({
  components: {
    UnorderedList,
    ListItem,
    RadioButton,
    Price,
  },
})
// 現在レンタルしている機器について教えてください。
export default class CurrentRentalEquipment extends Vue {
  public selectRadioList: { id: string; text: string, price: number }[] = [
    {
      id: 'hikari_phone_rental',
      text: 'ひかり電話ルーターをレンタルしている　',
      price: 200,
    },
    {
      id: 'home_gateway_rantal',
      text: 'ホームゲートウェイをレンタルしている　',
      price: 500,
    },
  ];
  mounted() {
    const value = this.$store.getters['hikari/router']
    if (value === 'hikari_phone_rental' || value === 'home_gateway_rantal') {
      this.$store.commit(`hikari/router`, value);
    } else {
      this.$store.commit(`hikari/router`, 'hikari_phone_rental');
    }
  }
}
